<template>
  <div id="content">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction"></popup>
    <div class="inner">
      <add-button v-if="$_updateActionAllowed" :title="'Přidat lokalitu' | translate" route-name="localitiesNew"></add-button>
      <h1 v-translate>Lokality</h1>
    </div>
    <div class="inner_white">
      <div class="filter">
        <div class="field_left">
          <search-input input-class="search" v-model="formFields.search"></search-input>
        </div>
        <a @click.stop.prevent="resetFilter" class="btn btn_action btn_grey btn_reset"
           :title="'Resetovat filtr' | translate" v-translate>Resetovat filtr</a>
      </div>

      <div class="scroll-wrapper">
        <div class="table_overflow" id="contentBox" data-table-id="localities-list">
          <table class="vypis vypis_detail">
            <thead>
            <tr v-if="entities.length > 0">
              <th class="no_padding drag_drop"></th>
              <th class="no_padding checkbox"></th>
              <sorting-table-title
                  v-for="title in localitiesTableTitles"
                  :key="title.key"
                  :column="title.column"
                  :sort="getActiveSort(title.column)"
                  @changeSorting="changeSorting"
              >{{ title.name }}
              </sorting-table-title>
              <th class="no_padding edit"></th>
            </tr>
            </thead>

            <locality-row
                v-for="entity in entities"
                :entity="entity"
                :key="entity.id"
                :selectedEntities="selectedEntities"
                @input="select"
                @deleteLocality="deleteEntity"
                :ref="'locality-row-ref-'+entity.id"
            ></locality-row>
              <tr v-if="entities.length === 0">
                   <td colspan="8">{{ $gettext('Nebyly nalezeny žádné lokality.') }}</td>
              </tr>
          </table>
        </div>
      </div>
      <list-action-line
          :entities="entities"
          :offset="formFields.offset"
          :limit="formFields.limit"
          :total-count="totalCount"
          table-id="localities-list"
          @limit="setLimit"
          @offset="setOffset"
          ref="action_line"
      ></list-action-line>
    </div>
  </div>
</template>

<script>
import LocalityRow from "@/components/views/localities/LocalityRow"
import listActions from "@/components/mixins/list-actions"
import localities from "./mixins/localities";

export default {
  name: "Localities",
  components: {
    LocalityRow,
  },
  mixins: [listActions],
  data() {
    return {
      moduleName: 'localities',
      formFields: {
        sort: {
          column: 'sName',
          direction: 'desc',
        }
      }
    }
  },
  created(LocalityService) {
    this.entityService = LocalityService
    this.createdInit()
  },
  computed: {
    localitiesTableTitles() {
      return [
        {key: 1, name: this.$gettext('Název'), column: 'sName'},
        {key: 2, name: this.$gettext('Operátor'), column: 'sOperatorName'},
        {key: 3, name: this.$gettext('Odstávka'), column: 'sMaintenance'},
        {key: 4, name: this.$gettext('Počet IP prefixů'), column: 'sPrefixesCount'},
        {key: 5, name: this.$gettext('Počet zdrojů obsahu'), column: 'sContentSourcesCount'}
      ]
    }
  },
  methods: {
    _processListErrorMessage(error) {
      let errorMessage = null;

      this._.forEach(error['validation_errors'], function (message) {
        if (message.match("^Unable to delete locality - there are (.+) device types with given locality\.$")) {
          errorMessage = this.$gettext("Protokol nelze smazat - existují typy zařízení s tímto protokolem.");
        } else {
          errorMessage = message;
        }
      }.bind(this))

      return errorMessage || error['error_message'];
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/localities/LocalitiesList.vue